import { GridLegacy } from "@mui/material";
import React, { useRef, useState } from "react";
import { menuSelect } from "../ComponentInterface";
import { Prefixes } from "../MainPage/Tools/ProjectX";
import smetaAxios from "../SmetaAxios";
import { getLastLogin } from "../Url";
import SignInEditor from "./signInTools/SignInEditor";
import { getEditorListFormat } from "../MainPage/Tools/Tools";

// eslint-disable-next-line @typescript-eslint/naming-convention
const SelectWorkPlace = (props: menuSelect) => {
  const lastWorkPlace = useRef(getLastLogin().split(","));
  const [workplaces, setWorkPlaces] = useState<Record<string, string>>({});

  const getWorkPlaces = async () => {
    if (props.userInfo !== "" && props.drxInfo !== "") {
      setWorkPlaces(
        await smetaAxios.get("getworkplacelist", {
          prefix: Prefixes.default,
          params: { ConfigName: encodeURIComponent(props.drxInfo), UserName: encodeURIComponent(props.userInfo) },
          loadMask: true,
        }),
      );
    }
  };

  const onKeyEnter = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter") {
      props.KeyDown(e);
    } else if (e.key === "ArrowDown") {
      getWorkPlaces();
    }
  };

  function menuItems(userList: Record<string, string>) {
    return getEditorListFormat(Object.values(userList));
  }

  return (
    <GridLegacy item xs>
      <SignInEditor
        label={"Рабочее место"}
        onKeyDown={onKeyEnter}
        onPickListButtonClick={getWorkPlaces}
        items={menuItems(workplaces)}
        onEdit={props.setBackInfo}
        defaultValue={{
          label: lastWorkPlace.current === undefined ? "" : lastWorkPlace.current[2],
        }}
      />
    </GridLegacy>
  );
};

export default SelectWorkPlace;
